class ExternalDataStore {
	constructor() {
		this.contexts = {}
	}

	setData(key, newData) {
		this.contexts[key] = newData;
	}
	getData(key) {
		return this.contexts[key]
	}
}

export default new ExternalDataStore();